/**
 * List of data to delete data when logout
 */
export function deleteData() {
  return Promise.all([]);
}
